export const getLineHeight = (fontSize = 28): number => fontSize * 1.2;
